import React from 'react';
import img from '../images/Web-developer.svg';
import { Link } from 'react-router-dom';

const Intro = () => {
    return (
        <div id="about" className="bg-gray-100 pt-24">
            <section data-aos="zoom-in-down">
                <div className="py-8">
                    <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">About Us</h2>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-blue-900'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">
                        Empowering Businesses with Cutting-Edge AI and Software Solutions
                    </h2>
                </div>

                <div className="container mx-auto px-4 lg:px-20" data-aos="fade-up">
                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <img alt="card img" className="rounded-t float-right transform hover:scale-105 transition duration-500 ease-in-out" src={img} />
                        </div>
                        <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8" data-aos="zoom-in" data-aos-delay="500">
                            <div className="mb-8">
                                <h3 className="text-2xl font-bold text-blue-900 mb-4">Who We Are</h3>
                                <p className='text-xl text-gray-600 font-semibold leading-relaxed'>
                                    NexAI Solution is a leading technology company specializing in AI-driven solutions and custom software development. Our team of expert developers and AI specialists is dedicated to transforming your business vision into reality.
                                </p>
                            </div>
                            
                            <div className="mb-8">
                                <h3 className="text-2xl font-bold text-blue-900 mb-4">What We Do</h3>
                                <ul className="space-y-4">
                                    <li className="flex items-start">
                                        <svg className="w-6 h-6 text-blue-900 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <p className='text-xl text-gray-600 font-semibold'>
                                            Develop custom AI solutions to optimize your business processes
                                        </p>
                                    </li>
                                    <li className="flex items-start">
                                        <svg className="w-6 h-6 text-blue-900 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <p className='text-xl text-gray-600 font-semibold'>
                                            Build scalable web and mobile applications tailored to your needs
                                        </p>
                                    </li>
                                    <li className="flex items-start">
                                        <svg className="w-6 h-6 text-blue-900 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <p className='text-xl text-gray-600 font-semibold'>
                                            Provide expert IT consulting and cloud solutions
                                        </p>
                                    </li>
                                </ul>
                            </div>

                            <Link to="/contact" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center px-8 py-4 text-lg shadow-xl rounded-xl transition duration-300 ease-in-out transform hover:scale-105 group">
                                Get Started
                                <svg className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform duration-300 ease-in-out" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Intro;